import React from 'react';
import classes from './Textarea.module.scss';

const Textarea = ({ ...rest }: React.TextareaHTMLAttributes<HTMLTextAreaElement>) => {
   return <textarea className={classes.textarea} {...rest}></textarea>;
};

export default Textarea;
